// extracted by mini-css-extract-plugin
module.exports = {"datasourceWithChildrenContentResolver":"DatasourceWithChildrenContentResolver_datasourceWithChildrenContentResolver___gv5c"};